const quotationChat = {
  quotationChatNavLabel: "견적 문의 채팅", // translated 
  quotationChatApprovalTitle: "견적 문의 채팅", // translated 
  quotationChatAccountNotApprovedTitle: "계정이 승인되지 않았습니다", // translated 
  quotationChatAccountNotApprovedDescription:
    "귀하의 계정은 아직 승인되지 않았습니다. 자세한 내용은 계정 관리자에게 문의하십시오.", // translated 
  quotationChatViewAiChat: "AI 채팅 보기", // translated 

  quotationRequestChatSessions: "채팅 세션", // translated 
  quotationRequestChatNoPastSessions: "이전 세션 없음", // translated 
  quotationRequestChatNewChat: "새 채팅", // translated 
  quotationRequestChatCloseSidebar: "사이드바 닫기", // translated 
  quotationRequestChatSessionFallback: "채팅 세션", // translated 
  quotationRequestChatDefaultSessionName: "새 채팅 세션", // translated 
  quotationRequestChatTitle: "견적 요청 채팅", // translated 
  quotationRequestChatResponseLanguageLabel: "응답 언어", // translated 
  quotationRequestChatOpenSidebar: "사이드바 열기", // translated 
  quotationRequestChatRenameSession: "세션 이름 변경", // translated 
  quotationRequestChatDeleteSession: "세션 삭제", // translated 
  quotationRequestChatToggleDarkMode: "다크 모드 전환", // translated 
  quotationRequestChatSwitchToLightMode: "조명 모드로 전환", // translated 
  quotationRequestChatSwitchToDarkMode: "다크 모드로 전환", // translated 
  quotationRequestChatEmptyStateHeading: "새로운 견적 요청 대화를 시작하세요", // translated 
  quotationRequestChatEmptyStateSubheading:
    "여행 계획에 필요한 사항을 알려주시면 견적 요청서를 작성해 드리겠습니다.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "대화를 시작하려면 메시지를 입력하세요... (Shift+Enter를 누르면 새 줄이 됩니다)", // translated 
  quotationRequestChatMessagePlaceholder: "메시지를 입력하세요... (새 줄을 입력하려면 Shift+Enter를 누르세요)", // translated 
  quotationRequestChatUploadFile: "파일 업로드", // translated 
  quotationRequestChatUploadAttachment: "첨부파일 업로드", // translated 

  quotationRequestChatStopGenerating: "생성 중지", // translated 
  quotationRequestChatGenerateQuotation: "견적서 생성", // translated 
  quotationRequestChatGenerateFinalQuotation: "최종 견적서 생성", // translated 
  quotationRequestChatFinalizeQuotationRequest: "견적 요청 완료", // translated 
  quotationRequestChatHoldToRecord: "길게 누르면 음성 메시지가 녹음됩니다.", // translated 
  quotationRequestChatRecordingReleaseToSend: "녹음, 전송용 릴리스", // translated 
  quotationRequestChatRecording: "녹음...", // translated 
  quotationRequestChatSelectSessionFirst: "먼저 채팅 세션을 선택해 주세요.", // translated 
  quotationRequestChatCancelVoiceRecording: "음성 녹음 취소", // translated 
  quotationRequestChatListening: "청취...", // translated 
  quotationRequestChatTranscribing: "입력 중...", // translated 

  quotationRequestChatFileUploadedSuccess: "파일이 성공적으로 업로드되었습니다.", // translated 
  quotationRequestChatFailedCreateSession: "채팅 세션을 생성하는 데 실패했습니다. 다시 시도해 주세요.", // translated 
  quotationRequestChatFailedUploadFile: "파일 업로드에 실패했습니다. 다시 시도해 주세요.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "다음 메시지를 보내기 전에 남아 있는 질문에 답변해 주세요.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "견적 요청을 최종 확정하기 전에 다음 질문에 답변해 주시기 바랍니다.", // translated 
  quotationRequestChatFavoriteMarked: "채팅 세션을 즐겨찾기로 표시했습니다.", // translated 
  quotationRequestChatFavoriteUnmarked: "채팅 세션을 즐겨찾기로 표시하지 않음", // translated 
  quotationRequestChatFailedSetFavorite: "즐겨찾기 설정에 실패했습니다", // translated 
  quotationRequestChatFailedUnsetFavorite: "즐겨찾기 해제에 실패했습니다.", // translated 
  quotationRequestChatRenamedSuccess: "채팅 세션 이름 변경이 성공적으로 완료되었습니다.", // translated 
  quotationRequestChatFailedRename: "채팅 세션 이름 변경에 실패했습니다. 다시 시도해 주세요.", // translated 
  quotationRequestChatDeletedSuccess: "채팅 세션이 성공적으로 삭제되었습니다.", // translated 
  quotationRequestChatFailedDelete: "채팅 세션을 삭제하는 데 실패했습니다. 다시 시도해 주세요.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "첨부 파일이 성공적으로 삭제되었습니다.", // translated 
  quotationRequestChatFailedDeleteAttachment: "첨부 파일을 삭제하는 데 실패했습니다. 다시 시도해 주세요.", // translated 
  quotationRequestChatSubmittedSuccess:
    "견적 요청이 성공적으로 제출되었습니다! 요청이 처리 중입니다.", // translated 
  quotationRequestChatFailedSubmit: "견적 요청 제출에 실패했습니다.", // translated 
  quotationChatPdfDownloadedSuccess: "PDF 파일이 성공적으로 다운로드되었습니다!", // translated 
  quotationChatFailedGeneratePdf: "PDF 생성에 실패했습니다.", // translated 

  quotationRequestChatSubagentRequired:
    "견적 요청을 제출하기 전에 하위 에이전트 사용자를 선택하십시오.", // translated 
  quotationRequestChatAppUserLoading:
    "CRM 앱 사용자 프로필이 아직 로드 중입니다. 잠시 후 다시 시도해 주세요.", // translated 
  quotationRequestChatAppUserMismatch:
    "귀하의 CRM 앱 사용자 프로필이 이 채팅 세션과 일치하지 않습니다.", // translated 

  quotationRequestChatRenameTitle: "채팅 세션 이름 변경", // translated 
  quotationRequestChatSessionName: "세션 이름", // translated 
  quotationRequestChatEnterSessionName: "세션 이름을 입력하세요", // translated 
  quotationRequestChatSaving: "절약...", // translated 
  quotationRequestChatSave: "구하다", // translated 
  quotationRequestChatDeleteTitle: "채팅 세션 삭제", // translated 
  quotationRequestChatDeleteConfirm: "이 채팅 세션을 삭제하시겠습니까?", // translated 
  quotationRequestChatDeleteCannotUndo: "이 작업은 되돌릴 수 없습니다.", // translated 
  quotationRequestChatDeleting: "삭제 중...", // translated 
  quotationRequestChatDelete: "삭제", // translated 

  quotationRequestChatAttachmentsTitle: "견적 요청 채팅 첨부 파일", // translated 
  quotationRequestChatLoadingAttachments: "첨부 파일을 불러오는 중...", // translated 
  quotationRequestChatNoAttachments: "첨부 파일이 없습니다.", // translated 
  quotationRequestChatDeleteAttachment: "첨부파일 삭제", // translated 
  quotationRequestChatUploadingAttachment: "첨부파일 업로드 중...", // translated 
  quotationRequestChatUploadingAttachmentWait: "파일 업로드가 진행 중입니다. 잠시 기다려 주세요.", // translated 

  quotationRequestChatAnswerPendingQuestions: "답변이 필요한 질문들", // translated 
  quotationRequestChatProposeOwnAnswer: "제 나름대로 답을 제시해 보세요.", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "직접 답변을 입력해 보세요...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{answered}} of {{total}} answered", // translated 
  quotationRequestChatReadyToSubmit: "제출 준비 완료", // translated 
  quotationRequestChatSubmitAll: "모두 제출", // translated 
  quotationRequestChatRespondToOneQuestion: "{{count}}개의 질문에 답변하세요", // translated 
  quotationRequestChatRespondToManyQuestions: "{{count}}개의 질문에 답변하세요", // translated 

  quotationRequestChatFinalizeTitle: "견적 요청 완료", // translated 
  quotationRequestChatLoadingSessionData: "세션 데이터를 불러오는 중...", // translated 
  quotationRequestChatErrorLoadingSession: "세션 데이터를 불러오는 데 오류가 발생했습니다. 다시 시도해 주세요.", // translated 
  quotationRequestChatQuotationTitle: "인용문 제목", // translated 
  quotationRequestChatExtraComments: "추가 의견", // translated 
  quotationRequestChatSubmitting: "제출 중...", // translated 
  quotationRequestChatSubmit: "제출하다", // translated 
  quotationRequestChatSubmittingOverlayTitle: "견적 요청을 제출합니다...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "견적 요청이 제출되는 동안 잠시 기다려 주십시오.", // translated 

  quotationRequestChatSelectSubagent: "하위 에이전트를 선택하세요", // translated 
  quotationRequestChatSearchSubagents: "하위 에이전트를 검색하세요...", // translated 
  quotationRequestChatLoadingSubagents: "하위 에이전트를 불러오는 중...", // translated 
  quotationRequestChatNoSubagentsFound: "하위 에이전트가 발견되지 않았습니다.", // translated 
  quotationRequestChatNoSubagentsAvailable: "이용 가능한 하위 에이전트가 없습니다.", // translated 
  quotationRequestChatSelectedSubagent: "선택됨: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "하위 에이전트 사용자", // translated 
  quotationRequestChatSearchUsers: "사용자 검색...", // translated 
  quotationRequestChatNoUsersFound: "사용자를 찾을 수 없습니다.", // translated 
  quotationRequestChatNoUsersAvailable: "사용 가능한 사용자가 없습니다.", // translated 

  quotationChatDownloadSummaryTitle: "견적 요약서를 다운로드하세요", // translated 
  quotationChatDownloadSummaryDescription:
    "아래에 정보를 입력하시면 맞춤형 여행 견적 PDF 요약본을 생성해 드립니다. PDF에는 모든 여행 세부 정보, 목적지, 교통 정보 및 일별 일정이 포함됩니다.", // translated 
  quotationChatCustomerTitle: "제목", // translated 
  quotationChatSelectTitle: "제목을 선택하세요", // translated 
  quotationChatHonorificMr: "씨.", // translated 
  quotationChatHonorificMrs: "부인", // translated 
  quotationChatHonorificMs: "여사", // translated 
  quotationChatHonorificDr: "박사님", // translated 
  quotationChatHonorificProf: "교수님", // translated 
  quotationChatCustomerPhone: "핸드폰", // translated 
  quotationChatCustomerCompany: "회사", // translated 
  quotationChatCustomerMessage: "메시지", // translated 
  quotationChatCustomerCountry: "국가", // translated 
  quotationChatGenerating: "생성 중...", // translated 
  quotationChatDownloadPdf: "PDF 다운로드", // translated 

  quotationChatTripSummary: "여행 요약", // translated 
  quotationChatDownloadAsPdf: "PDF로 다운로드", // translated 
  quotationChatNoTripSummary: "이번 회차에 대한 여행 요약 정보가 없습니다.", // translated 

  quotationRequestChatThinking: "생각...", // translated 
  quotationRequestChatSources: "출처", // translated 
  quotationRequestChatSearchingWebFor: '웹에서 "{{query}}"를 검색하는 중...', // translated 
  quotationRequestChatServicesByTourOperator: "여행사가 제공하는 서비스", // translated 
  quotationRequestChatServicesByCustomer: "고객이 처리하는 서비스", // translated 
  quotationRequestChatReadyNotice:
    "오른쪽 버튼을 클릭하시면 해당 요청에 대한 견적서를 받아보실 수 있습니다.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "최종 견적서 생성", // translated 

  quotationRequestChatMaybeYouWantToAsk: "혹시 이런 질문을 하고 싶으신가요?", // translated 
  quotationRequestChatClickToSendSuggestion: "이 메시지를 보내려면 클릭하세요.", // translated 

  quotationRequestChatAddToFavorites: "즐겨찾기에 추가", // translated 
  quotationRequestChatRemoveFromFavorites: "즐겨찾기에서 제거", // translated 
  quotationRequestChatSubmitted: "제출된", // translated 

  quotationRequestChatQuotationRequest: "견적 요청: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{제목}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- 상태: {{status}}", // translated 

  quotationChatLoading: "로딩 중...", // translated 
  quotationChatSessionNotFound: "이 견적에 대한 채팅 세션을 찾을 수 없습니다.", // translated 
  quotationChatMemberSessionNotFound: "회원 계정에 대한 멤버 세션을 찾을 수 없습니다.", // translated 
  quotationChatUnableToConnect: "채팅에 연결할 수 없습니다", // translated 
  quotationChatConnecting: "연결 중...", // translated 
  quotationChatTypeYourMessage: "메시지를 입력하세요...", // translated 
  quotationChatConnected: "연결됨", // translated 
  quotationChatConnectingStatus: "연결 중...", // translated 
  quotationChatDisconnected: "연결이 끊어졌습니다", // translated 
};


export default quotationChat;
